import { useMutation, gql } from '@apollo/client'

const useIssueCheckInToStudentBulk = (onSuccess = () => {}, onError = () => {}) => {
  return useMutation(
    gql`
      mutation (
        $events: [CheckInBulkEventInput!]!
      ) {
        issueCheckInToStudentBulk(
          events: $events
        ) {
          total
          sent
          failed
          results {
            eventKey
            status
            errorCode
            errorMessage
          }
        }
      }
    `,
    {
      onCompleted: onSuccess,
      onError
    }
  )
}

export default useIssueCheckInToStudentBulk
